
const bug = () => import('./pages/bug.vue');

export default [{
    name: 'debugger-index',
    path: '/debugger/index',
    component: bug
  }]


// WEBPACK FOOTER //
// ./src/modules/bug/routes.js